import * as constants from './constants'

export const setCookies = data => ({
    type: constants.SET_COOKIES,
    data,
})

export const openCookiesModal = () => ({
    type: constants.OPEN_COOKIES_MODAL,
})
